define(["require", "exports", "./BootstrapClassManager", "./BootstrapManager"], function (require, exports, BootstrapClassManager_1, BootstrapManager_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.BootstrapControllerBase = void 0;
    var BootstrapControllerBase = (function () {
        function BootstrapControllerBase() {
        }
        BootstrapControllerBase.prototype.start = function (vueObj) {
            var bootsMgr = BootstrapClassManager_1.BootStrapClassManager.getInstance();
            var query = vueObj.$route.query;
            bootsMgr.saveParamsData({
                flowCode: query.flowCode || 'test code',
                token: query.token || 'test token',
                language: BootstrapManager_1.bootStrapManager.getConfig().locale,
                unitCode: vueObj.$route.path || ''
            });
            return bootsMgr;
        };
        BootstrapControllerBase.prototype.updateNavBar = function (vueObj, busValue) {
            if (vueObj && vueObj.$refs && vueObj.$refs.headTitle) {
                var headTitle = vueObj.$refs.headTitle;
                if (headTitle && headTitle.$refs && headTitle.$refs.headerItem) {
                    var haedItem = headTitle.$refs.headerItem;
                    if (busValue && busValue.showNavBar && +busValue.showNavBar.configValue === 1) {
                        haedItem.style.display = '';
                    }
                    else {
                        haedItem.style.display = 'none';
                    }
                }
            }
        };
        BootstrapControllerBase.prototype.updateThemeColor = function (busValue) {
        };
        BootstrapControllerBase.prototype.updateFontColor = function (busValue) {
        };
        BootstrapControllerBase.prototype.skipGuide = function (vueObj, busValue) {
            if (vueObj && vueObj.$refs && vueObj.$refs.agreementLayer && vueObj.$refs.vertifyLayer) {
                var agreementLayer = vueObj.$refs.agreementLayer;
                var vertifyLayer = vueObj.$refs.vertifyLayer;
                if (agreementLayer && vertifyLayer) {
                    if (busValue && busValue.skipGuide && +busValue.skipGuide.configValue === 1) {
                        agreementLayer.style.display = 'none';
                        vertifyLayer.style.display = '';
                    }
                    else {
                        agreementLayer.style.display = '';
                        vertifyLayer.style.display = 'none';
                    }
                }
            }
        };
        return BootstrapControllerBase;
    }());
    exports.BootstrapControllerBase = BootstrapControllerBase;
});
//# sourceMappingURL=BootstrapControllerBase.js.map